import { User, UserSpeciality } from '../types/User'
import { SUser, SUserSpecialty } from '../types/api/User'

import { userProfileTransformer } from './userProfileTransformer'
import { userSpecialityTransformer } from './userSpecialityTransformer'

export const userTransformer = (data: SUser): User => {
  const { id, documentId, profile, speciality, ...rest } = data as any
  return {
    ...rest,
    id: id != null ? String(id) : documentId ?? '',
    ...(documentId != null && String(documentId) !== ''
      ? { documentId: String(documentId) }
      : {}),
    ...(profile && {
      profile: userProfileTransformer(profile),
    }),
    ...(speciality && {
      speciality: userSpecialityTransformer(speciality),
    }),
  } as User
}

export const userSpecialtyTransformer = (
  data: SUserSpecialty
): UserSpeciality => {
  return {
    id: data.id != null ? String(data.id) : data.documentId ?? '',
    name: data.name,
  }
}
